import React from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { injectModels } from "../../../redux/injectModels";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { InquiryService } from "../../../services";
import { handleConsoleError } from "../../../utils/common-methods";

function Contact(props) {
  const [currentPage, setCurrentPage] = useState(0);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [filteredData, setFilteredData] = useState([]);

  const [showModal, setShow] = useState(false);
  const [error, setError] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);

  // Enquiry List API
  const getData = async () => {
    props.application.setLoading(true);
    try {
      const res = await InquiryService.getContactUsList();
      if (res?.data) {
        setFilteredData(res?.data);

        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  //   Enquiry View Only
  const handleEdit = async (id) => {
    try {
      props.application.setLoading(true);
      const res = await InquiryService.getContactUsById(id);

      if (res?.isSuccess) {
        setFirstName(res?.data?.firstName);
        setLastName(res?.data?.lastName);
        setEmail(res?.data?.email);
        setPhoneNo(res?.data?.phone);
        setDescription(res?.data?.message);
        handleShow();
        props.application.setLoading(false);
      } else {
        toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error)
      toast.error(error?.message || message);
    }
  };

  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);

    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }

    const pageCount = Math.ceil(filteredData.length / rowsPerPage);

    if (filteredData.length === 0) {
      setShowNextButton(false);
    } else if (selected === pageCount - 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };

  // const renderPagination = () => {
  //   const pageCount = Math.ceil(filteredData.length / rowsPerPage);
  //   if (pageCount > 1) {
  //     return (
  //       <ReactPaginate
  //         pageCount={pageCount}
  //         pageRangeDisplayed={5}
  //         marginPagesDisplayed={2}
  //         onPageChange={handlePageChange}
  //         forcePage={currentPage}
  //         containerClassName="pagination"
  //         activeClassName="active"
  //         previousLabel={showPreviousButton ? "Previous" : null}
  //         nextLabel={showNextButton ? "Next" : null}
  //         breakLabel="..."
  //         disableInitialCallback={true}
  //       />
  //     );
  //   }
  //   return null;
  // };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            {/* <li className="breadcrumb-item">Content Management</li>*/}
            <li className="breadcrumb-item active">Enquiry</li>
          </ol>
        </nav>
      </div>

      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        className="custom-contract-modal"
      >
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>Enquiry Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="searchformfld">
              <label>
                First Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="First Name"
                value={firstName}
                maxLength="100"
                required
                disabled
              />

              <label>
                Last Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="last Name"
                value={lastName}
                maxLength="100"
                required
                disabled
              />

              <label>
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="email"
                value={email}
                maxLength="100"
                required
                disabled
              />

              <label>
                Phone Number <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="phoneNo"
                value={phoneNo}
                maxLength="100"
                required
                disabled
              />

              <label>
                Message <span className="text-danger">*</span>
              </label>
              <textarea
                type="test"
                className="form-control mb-3"
                placeholder="description"
                value={description}
                maxLength="100"
                required
                disabled
              />
            </div>
            {error && <span className="text-danger">{error}</span>}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="table-responsive">
        <div>
          <h2>Enquiry</h2>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Phone No</th>
              <th>Email Address</th>
              <th>Message</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{item?.firstName + " " + item?.lastName}</td>
                      <td>{item?.phone}</td>
                      <td>{item?.email}</td>
                      <td>{item?.message}</td>
                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(item?.id);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="fa-solid fa-eye"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <p className="mb-3">
          <strong>Total Count: {filteredData.length}</strong>
        </p>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
}
export default injectModels(["admin", "application"])(Contact);
